import { AbsolutePositioned } from './AbsolutePositioned';
import { brandColors, device } from '../../styles/variables';

const Panel = AbsolutePositioned.extend`
  ${({ backgroundColor }) => `
    background: ${backgroundColor || brandColors.yellow};
    height: 45%;
    width: 50%;
    padding: 30px 2% 0;
    @media ${device.tablet} {
      height: 50%;
    }
    @media ${device.laptop} {
      padding: 2px 2% 0;
    }
    .content {
      @media ${device.laptop} {
        width: 80%;
      }
    }
    &.mobileDisplayNone {
      display: none;
      @media ${device.tablet} {
        display: block;
      }
    }
  `};
`;

export { Panel };



// WEBPACK FOOTER //
// ./src/components/Layout/Panel.jsx